import { useQuery } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import type { ListRequest, Paged } from "@/core/api/pagination";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { walletEndpoints } from "@/features/wallet/api/endpoints";
import type {
  TransactionDisputeDto,
  TransactionDisputeFilter,
} from "@/features/wallet/api/dto";

/**
 * File de travail paginée des contestations (`POST /TransactionDisputes/all`,
 * guide v3.1 — les listes sont en POST, §4.2). Un client n'obtient que ses
 * propres ouvertures ; le back-office et les comptes de service voient
 * l'ensemble. Lecture authentifiée : `mutateData` en queryFn, la requête
 * reste une query TanStack (cache, invalidation).
 */
export const useTransactionDisputes = (
  params: ListRequest<TransactionDisputeFilter> = {},
  enabled = true
) =>
  useQuery({
    queryKey: QUERY_KEYS.WALLET_TRANSACTION_DISPUTES_LIST(params),
    queryFn: () =>
      mutateData({
        url: walletEndpoints.transactionDisputes.all,
        reqBody: params as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<Paged<TransactionDisputeDto>>,
    enabled,
  });
